module.exports = __webpack_public_path__ + "static/media/donate.a26549b2.svg";